import { render, staticRenderFns } from "./DeleteDomainIcon.vue?vue&type=template&id=63c8bb15&"
import script from "./DeleteDomainIcon.vue?vue&type=script&lang=js&"
export * from "./DeleteDomainIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports